import React from 'react';
import { htmlDecode } from '../helpers/functions';
import cx from 'classnames';

export function PageBanner({
  title,
  breadcrumbs,
  backgroundImage,
  removeMargin,
}) {
  return (
    <header
      className={cx(
        `bg-secondary text-center py-8 bg-cover`,
        !removeMargin && `mb-12`
      )}
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage.url})`
          : `none`,
      }}
    >
      <h1
        className="text-white text-26 md:text-40 font-secondary uppercase container"
        dangerouslySetInnerHTML={{ __html: htmlDecode(title) }}
      />
      {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
    </header>
  );
}

function Breadcrumbs({ breadcrumbs }) {
  return (
    <div className="">
      <div className="container flex justify-center text-white text-xs sm:text-base">
        {breadcrumbs.map((crumb, key) => {
          if (crumb.href) {
            return (
              <div className="mr-1 sm:mr-2 flex items-center" key={key}>
                <a
                  href={crumb.href}
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(crumb.text),
                  }}
                  className="inline-block py-2 px-2 sm:px-4 mr-1 sm:mr-2 text-white no-underline"
                />
                <span>{` / `}</span>
              </div>
            );
          }
          return (
            <span
              key={key}
              className="inline-block py-2 px-4"
              dangerouslySetInnerHTML={{ __html: htmlDecode(crumb.text) }}
            />
          );
        })}
      </div>
    </div>
  );
}
